import React from 'react';
import ReactDOM from 'react-dom';
import HeroSection from '../components/HeroSection';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderHeroSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<HeroSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering HeroSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};